import React, { useEffect, useState, createContext, useContext } from "react";
import {
  Navigate,
  Route,
  Routes,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Register from "../pages/admin/Register";
import ProtectedRoute from "../config/protectedRoute";
import { auth } from "../config/config";
import Layout from "../components/layout";
import { useAppContext } from "../context/appContext";
import ManagementLogin from "../pages/management/ManagementLogin";
import ManegmentHome from "../pages/management/manegmentHome";
import ManagementReport from "../pages/management/managementReport";
import ViewManagementReport from "../pages/management/viewManagementReport";
import ResetPassword from "../pages/management/ResetPassword";

// Create a context to manage unsaved changes
const UnsavedChangesContext = createContext();

export const useUnsavedChanges = () => {
  return useContext(UnsavedChangesContext);
};

const Routers = () => {
  const { UserType, isAuthenticated } = useAppContext();
  const [currentUser, setCurrentUser] = useState(null);
  const [isChangesInCreateReport, setIsChangesInCreateReport] = useState(false);

  const RedirectToExternal = () => {
    useEffect(() => {
      window.location.replace("https://login.maximalsecurityservices.com/");
    }, []);

    return null;
  };


  return (
    <UnsavedChangesContext.Provider
      value={{ isChangesInCreateReport, setIsChangesInCreateReport }}
    >
      <Layout>
        <Routes>
          <Route path="/login" element={<ManagementLogin />} />
          {!isAuthenticated ? (
            <>
              {/* <Route path="*" element={<RedirectToExternal />} /> */}
              {/* <Route path="*" element={<Navigate to="/" />} /> */}
              <Route path="/" element={<ManagementLogin />} />
              <Route path="/register" element={<Register />} />
              <Route path="/resetpassword" element={<ResetPassword />} />
            </>
          ) : (
            <>
              <Route path="/" element={<Navigate to="/report" />} />
              <Route path="/home" element={<Navigate to="/report" />} />
              {/* <Route path="/home" element={<ManegmentHome />} /> */}
              <Route path="/report" element={<ManagementReport />} />
              <Route
                path="/report/:managereportId"
                element={<ViewManagementReport />}
              />
            </>
          )}
        </Routes>
      </Layout>
    </UnsavedChangesContext.Provider>
  );
};

export default Routers;
